<template>
  <div class="single-choice">
    <div class="content-stem">
      <div class="ques-num">第{{ currentQuestionIndex + 1 }}题</div>
      <span v-html="currentQuestion.content"/>

    </div>
    <div class="content-list">
      <div class="content-option" v-for="(option, index) in currentQuestion.optionList" :key="index">
        <label>
          <input type="radio" name="singleQuestion" :value="option.quesValue" :checked="hasAns(option.quesValue)"
                 @click="radioToggleFn">
          <strong v-if="currentQuestion.quesTypeID==1">{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption"/>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ExamSingleChoice',
    computed: {
      ...mapGetters([
        'currentQuestion',
        'currentQuestionIndex'
      ])
    },
    methods: {
      hasAns(old) {
        let userAns = this.currentQuestion.userAnswer
        let flag = false
        if (userAns && userAns === old) {
          flag = true
        }
        return flag
      },
      radioToggleFn(e) {
        this.$nextTick(() => {
          let value = this.currentQuestion.userAnswer === e.target.value ? '' : e.target.value
          let isAnswer = value ? 1 : 0
          this.$store.dispatch('setUserAns', value)
          this.$store.dispatch('setIsAns', isAnswer)
        })
      }
    }
  }
</script>
